import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, vendorSKUValidation } from "./vendor-sku-schema";
import VendorSKUInfo from "./components/VendorSKUInfo";
import { getVendorSKUByCode } from "services/data.internal.service";
import { editVendorSKU } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { useLocation } from "react-router-dom";

function EditVendorSKU() {
  const location = useLocation();
  const { skuCode, customerCode, vendorCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(initialValues);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["vendor-sku", { skuCode, customerCode, vendorCode }],
    queryFn: () => getVendorSKUByCode({ skuCode, customerCode, vendorCode }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editVendorSKUMutation = useMutation(editVendorSKU, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(vendorSKUValidation),
  });

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isDirty },
  } = form;

  const [
    defRecvWh,
    defRecvZone,
    defRecvLocation,
    defPutawayWh,
    defPutawayZone,
    defPutawayLocation,
    defTRPutawayWh,
    defTRPutawayZone,
    defTRPutawayLocation,
    defShipWh,
    defShipZone,
    defShipLocation,
  ] = watch([
    "defRecvWh",
    "defRecvZone",
    "defRecvLocation",
    "defPutawayWh",
    "defPutawayZone",
    "defPutawayLocation",
    "defTRPutawayWh",
    "defTRPutawayZone",
    "defTRPutawayLocation",
    "defShipWh",
    "defShipZone",
    "defShipLocation",
  ]);

  const infoProps = {
    mode: "EDIT",
    values: {
      customerCode,
      defRecvWh,
      defRecvZone,
      defRecvLocation,
      defPutawayWh,
      defPutawayZone,
      defPutawayLocation,
      defTRPutawayWh,
      defTRPutawayZone,
      defTRPutawayLocation,
      defShipWh,
      defShipZone,
      defShipLocation,
    },setValue,
    control,
    errors,
    formRender,
  };
  const onSubmit = (data) => {
    window.scrollTo(0, 0);
    editVendorSKUMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["vendor-sku"]),
    });
  };
  return (
    <Layout lg={12}>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <VendorSKUInfo {...infoProps} />
        <SaveButton label="save" disabled={!isDirty} url={-1} />
      </form>
    </Layout>
  );
}

export default EditVendorSKU;
